export enum ProjectsQueryKeys {
  GET_PROJECTS_LIST = 'GET_PROJECTS_LIST',
}
